import { DashboardOutlined, VerticalLeftOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import React from 'react';

const ActionButtonGroup: React.FC<{
    extraButton: JSX.Element;
}> = ({ extraButton }) => {

    const [popoverOpen, setPopoverOpen] = React.useState(true);


    return (
        <>
            {
                popoverOpen ?
                    <div className=' absolute bottom-6 right-6 z-50'>
                        <Space direction='vertical'>
                            {popoverOpen ? extraButton : null}
                            <Button size='large' shape="circle" onClick={() => setPopoverOpen(!popoverOpen)}>
                                <VerticalLeftOutlined />
                            </Button>
                        </Space>
                    </div> :
                    <>
                        <Button size='large' className=' absolute bottom-6 right-6 z-50' shape="circle" onClick={() => setPopoverOpen(!popoverOpen)}>
                            <DashboardOutlined />
                        </Button>
                    </>
            }
        </>

    );
};

export default ActionButtonGroup;